import { BOX_STATE, BOX_SUB_STATE } from '../constants/space.const';
import {
    getBoxJourneyPresentation,
    normalizeBoxStatus
} from './box-journey.helper';

import dayjs from 'root-js/plugins/Dayjs';

export const normalizeBoxId = value => {
    if (value === null || typeof value === 'undefined') {
        return null;
    }

    return String(value);
};

export const getBoxState = (packingStatus, status) => {
    if (status === 'AWAITING_PROCESSING') {
        return {
            badgeText: 'Processing',
            state: BOX_STATE.GRACE_PERIOD_PROCESSING,
            subState: ''
        };
    } else if (
        [
            'PICKED_UP_FROM_CUSTOMER',
            'DELIVERED_TO_WAREHOUSE',
            'READY_FOR_PICKUP',
            'READY_FOR_DROP_OFF'
        ].includes(status)
    ) {
        return {
            badgeText: 'Headed to Space',
            state: BOX_STATE.TRACK,
            subState: BOX_SUB_STATE.SENDING
        };
    } else if (
        [
            'PROCESSING',
            'REQUESTING',
            'REQUESTED',
            'SHIPPED_FROM_WAREHOUSE',
            'PICKED_UP_FROM_WAREHOUSE',
            'IN_TRANSIT'
        ].includes(status)
    ) {
        return {
            badgeText: 'Coming to you',
            state: BOX_STATE.TRACK,
            subState: BOX_SUB_STATE.ARRIVING_REQUEST
        };
    } else if (['READY_FOR_DROP_OFF', 'READY_FOR_PICKUP'].includes(status)) {
        return {};
    } else if (status === 'IN_WAREHOUSE') {
        return {
            badgeText: 'In Space',
            state: BOX_STATE.REQUEST
        };
    } else if (
        status === 'DELIVERED_TO_CUSTOMER'
        && packingStatus === 'unpacked'
    ) {
        return {
            badgeText: 'Arrived',
            state: BOX_STATE.START_PACKING
        };
    } else if (
        status === 'DELIVERED_TO_CUSTOMER'
        && packingStatus === 'packing'
    ) {
        return {
            badgeText: 'Arrived',
            state: BOX_STATE.CONTINUE_PACKING
        };
    } else if (
        status === 'DELIVERED_TO_CUSTOMER'
        && packingStatus === 'packed'
    ) {
        return {
            badgeText: 'Arrived',
            state: BOX_STATE.SEND_TO_SPACE
        };
    } else if (status === 'DELIVERY_FAILED') {
        return {};
    }

    return {
        badgeText: '',
        state: '',
        subState: ''
    };
};

export const formatBoxDetails = box => {
    const status = normalizeBoxStatus(box.status);
    const boxStates = getBoxState(box.packing_status, status);
    const boxImage = box.media.find(media => media.type === 'image');
    return {
        id: normalizeBoxId(box.id),
        badgeText: boxStates.badgeText,
        bundle: box.bundle,
        order: box.order || null,
        imageId: boxImage?.id,
        image: box?.media || [{ original: require('static/assets/images/misc/mint.webp') }],
        title: box.name || '',
        description: box.description || '',
        state: boxStates.state,
        subState: boxStates.subState,
        dateCreated: dayjs
            .utc(box.created_at)
            .local()
            .format('MMMM Do YYYY [at] hh:mm A'),
        dateCreatedUtcMs: dayjs.utc(box.created_at).valueOf(),
        dateUpdated: dayjs
            .utc(box.updated_at)
            .local()
            .format('MMMM Do YYYY [at] hh:mm A'),
        dateUpdatedUtcMs: dayjs.utc(box.updated_at).valueOf(),
        address: '1234 Main St, Los Angeles, CA, 90123',
        tags: box.tags,
        packingStatus: box.packing_status,
        status,
        journeyPresentation: getBoxJourneyPresentation({
            status,
            packingStatus: box.packing_status,
            subState: boxStates.subState
        }),
        serialNumber: box.serial_number,
        trial_expires_at:
            box.trial_expires_at !== undefined ? box.trial_expires_at : null
    };
};

export function mmToInches(mm) {
    const inchesPerMillimeter = 0.0393701;
    const inches = mm * inchesPerMillimeter;

    // Convert to a string with two decimal places
    const fixedInches = inches.toFixed(2);

    // If the result ends with ".00", return the integer part only
    return parseFloat(fixedInches) % 1 === 0
        ? parseInt(fixedInches)
        : parseFloat(fixedInches);
}
